import React from "react";
import IOverview from "./IOverview";
import OverviewBox from "../OverviewBox/OverviewBox";
import { IOverviewBox } from "../OverviewBox/IOverviewBox";
import { connect } from "react-redux";
import { TReducers } from "@features/reducers";
import {
  calculateOverviewValues,
  createOverviewData,
} from "@portfolio/features/helpers.portfolio";

import * as style from "./OverviewStyle.module.scss";
import * as pages from "@appStyles/pages.module.scss";

export const Overview: React.FunctionComponent<IOverview> = (props) => {
  const overviewData = () => {
    const overviewValues = calculateOverviewValues(props.companies);
    const { totalPaidOut, amountInvested, profit } = overviewValues;

    return createOverviewData(
      totalPaidOut.toString(),
      amountInvested.toString(),
      profit.toString()
    );
  };

  const renderData = (data: IOverviewBox[]): JSX.Element[] =>
    data.map((box) => <OverviewBox key={box.label} {...box} />);

  return (
    <div className={style.overview}>
      <h1 className={`${pages.header} nostyle`}>Overview</h1>
      <div className={style.flexColumns}>{renderData(overviewData())}</div>
    </div>
  );
};

const mapStateToProps = (store: TReducers) => ({
  companies: store.portfolioReducer.companies,
});

export default connect(mapStateToProps)(Overview);
